<template>
  <div style="margin-bottom:3rem">

    <v-dialog v-model="show" :class="{'filtr-active':showFilter}" width="1000">
      <v-btn slot="activator" block color="primary">
        {{ $t('archive.filter.filters') }}
      </v-btn>
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('archive.filter.filters') }}
        </v-card-title>
        <v-container>
          <div>
            <h2> {{ $t('archive.filter.choose_filter') }}</h2>
            <v-layout>
              <v-flex xs11>
                <v-select v-model="choosenFilter" :items="filters" :label="`${$t('form.inputs.select_field')}`" item-text="name"
                          item-value="id" @change="updateConditionFilter"></v-select>
              </v-flex>
              <v-flex v-if="editMode" xs1>
                <v-btn fab small @click="deleteFilter">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>

          <div v-if="choosenFilter!=0">
            <div>
              <v-switch v-model="editMode" :label="`Edytuj filtr`"></v-switch>
              <div>
                <h3> {{ $t('archive.filter.contains') }} : </h3>
                <div v-for="i in rangeContains" :key="i">
                  <v-layout>
                    <v-flex v-if="i!=1" sm3 xs5>
                      <v-select v-model="operatorsContains[i]" :items="operators" :label="`${$t('archive.filter.operator')}`" :readonly="!editMode"
                                item-text="name" item-value="value" prepend-icon="xxyyzz"
                                style="margin-left:2rem;"></v-select>
                    </v-flex>
                    <v-flex sm3 xs5>
                      <v-text-field v-model="searchContains[i]" :label="`${$t('archive.filter.phrase')}`" :readonly="!editMode"
                                    prepend-icon="search" required
                                    style="margin-left:2rem;"></v-text-field>
                    </v-flex>
                    <v-flex sm1 xs2>
                      <v-btn v-if="i!=1 && editMode" block fab small style="margin-left:2rem;"
                             @click="removeFiltrContains(i)">
                        <v-icon small>remove</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex v-if="i==rangeContains && editMode" sm2 xs2>
                      <v-btn fab small @click="rangeContains++">
                        <v-icon small>add</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </div>
              </div>

              <div>
                <h3> {{ $t('archive.filter.not_contains') }} : </h3>
                <div v-for="i in rangeNot" :key="i">
                  <v-layout>
                    <v-flex v-if="i!=1" sm3 xs5>
                      <v-select v-model="operatorsNot[i]" :items="operators" :label="`${$t('archive.filter.operator')}`" :readonly="!editMode"
                                item-text="name" item-value="value" prepend-icon="xxyyzz"
                                style="margin-left:2rem;"></v-select>
                    </v-flex>
                    <v-flex sm3 xs5>
                      <v-text-field v-model="searchNot[i]" :label="`${$t('archive.filter.phrase')}`" :readonly="!editMode"
                                    prepend-icon="search" required
                                    style="margin-left:2rem;"></v-text-field>
                    </v-flex>
                    <v-flex sm1 xs2>
                      <v-btn v-if="i!=1 && editMode" block fab small style="margin-left:2rem;"
                             @click="removeFiltrNot(i)">
                        <v-icon small>remove</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex v-if="i==rangeNot && editMode" sm2 xs2>
                      <v-btn fab small @click="rangeNot++">
                        <v-icon small>add</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>

            <!--  FILTRACJA   -->
            <v-layout style="margin-top:1rem">

              <v-flex xs4>
                <v-text-field v-model="type" :label="`${$t('archive.arch_type')}`" required></v-text-field>
              </v-flex>

            </v-layout>
            <v-layout>
              <v-flex>
                <v-btn @click="search">
                  {{ $t('archive.filter.search') }}
                </v-btn>
                <v-btn v-if="editMode" @click="update">
                  {{ $t('archive.filter.update_and_save') }}
                </v-btn>
              </v-flex>

            </v-layout>
            <!-- KONIEC FILTRACJI -->
          </div>
        </v-container>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      name: "",
      show: false,
      type: "",
      editMode: false,
      showSaveNameDialog: false,
      showSaveName: false,
      searchContains: [],
      rangeContains: 1,
      operatorsContains: [],
      searchNot: [],
      rangeNot: 1,
      operatorsNot: [],
      createFiltrer: true,
      sort: 1,
      place: 2,
      showFilter: false,
      operators: [{
        name: "AND",
        value: "AND"
      },
      {
        name: "OR",
        value: "OR"
      }
      ],
      choosenFilter: 0
    }
  },
  computed: {
    filters() {
      return this.$store.getters.archiveFilters
    },
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {

  },
  methods: {
    removeFiltrContains(index) {
      this.operatorsContains.splice(index, 1);
      this.searchContains.splice(index, 1)
      this.rangeContains--;
    },
    removeFiltrNot(index) {
      this.operatorsNot.splice(index, 1);
      this.searchNot.splice(index, 1)
      this.rangeNot--;
    },
    buildCondition() {
      let condition = {
        "name": this.name,
        "type": this.type
      }
      condition["contains"] = this.buildConditionFromData(this.searchContains, this.operatorsContains, this.rangeContains)
      condition["not"] = this.buildConditionFromData(this.searchNot, this.operatorsNot, this.rangeNot)
      return condition
    },
    buildConditionFromData(search, operatos, range) {
      let condition = []

      for (let i = 0; i <= range; i++) {
        if (search[i] == undefined || (operatos[i] == undefined && i > 1)) { // Ignore if search is empty or operator is empty when is needed (any field axcept first)
          continue;
        }
        let objCondition = {
          "id": i,
          search: search[i]
        }

        if (i > 1) {
          objCondition.operator = operatos[i]
        }
        condition.push(objCondition)
      }
      return condition
    },
    update() {
      let filters = this.buildCondition();
      if ((Object.keys(filters.contains).length > 0 || Object.keys(filters.not).length > 0) && this.choosenFilter > 0) {
        this.$store.dispatch('updateArchiveFilter', {id: this.choosenFilter, data: filters}).then((data) => {
          this.show = false
          this.showMessage(this.$t('archive.filter.updated'), "success")
          this.$emit('filter', data.data)
        }).catch(() => {
          this.showMessage(this.$t('archive.filter.updated_fail'), "danger")
        })

      }
    },
    search() {
      let filter = this.filters.find(filt => filt.id == this.choosenFilter)
      this.show = false
      this.$emit('filter', filter)
    },
    deleteFilter() {
      let id = this.choosenFilter
      this.$store.dispatch('deleteArchiveFilter', id).then(() => {
        this.choosenFilter = 0
        this.showMessage(this.$t('archive.filter.deleted'), "success")
      }).catch(() => {
        this.showMessage(this.$t('archive.filter.cannot_delete'), "danger")
      })
    },
    updateConditionFilter() {
      this.clearConditions();

      if (this.choosenFilter == 0) {
        return;
      }

      this.editMode = false
      let filter = this.filters.find(filter => filter.id == this.choosenFilter)
      this.setUpCondition(filter)

    },
    setUpCondition(filter) {
      filter.contains.forEach(con => {
        this.searchContains[con.id] = con.search
        this.rangeContains++;
        if (con.id > 1)
          this.operatorsContains[con.id] = con.operator
      })

      filter.not.forEach(con => {
        this.searchNot[con.id] = con.search
        this.rangeNot++;
        if (con.id > 1)
          this.operatorsNot[con.id] = con.operator
      })

      this.sort = filter.sort
      this.place = filter.place
      this.name = filter.name
      this.type = filter.type

      if (filter.not.length > 1)
        this.rangeNot--

      if (filter.contains.length > 1)
        this.rangeContains--

    },
    clearConditions() {
      this.searchNot = []
      this.rangeNot = 1;
      this.operatorsNot = []

      this.searchContains = []
      this.rangeContains = 1;
      this.operatorsContains = []
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  },
}
</script>

<style>
.filtr-active {
  background-color: green !important;
}
</style>
